import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import User from '@/pages/people-partners/User';
import mapResponse from '@/utils/mapResponse';

ProjectUser.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired
};

export default function ProjectUser(props) {
  const { user, project } = props;

  const questions = useConnect('question.find', {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          request: { $not: 'Outreach' }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  const question = _.find(questions.data, function(question) {
    return question.data.userId === user.id;
  });

  const selected = !!question;

  return (
    <User
      user={user}
      project={project}
      selected={selected}
      footer={question ? mapResponse(question.data.response) : undefined}
    />
  );
}
